module.exports = __webpack_public_path__ + "common/payment/icon-visa-51b04877588c002df205fb6fd529f44c.svg";